export const DRAWER_WIDTH = 320;
